module.exports = __webpack_public_path__ + "img/biaoqian_zhifajiluyi.9b2b385a.png";